'use strict';

var React = require('react');
require('prop-types');
var CurrencyDisplay = require('../CurrencyDisplay.js');
var PdfRenderableSplitRow = require('./PdfRenderableSplitRow.js');
var Typography = require('../../DesignSystem/DataDisplay/Typography/Typography.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var PriceRow = function PriceRow(_ref) {
  var label = _ref.label,
      amount = _ref.amount,
      labelVariant = _ref.labelVariant,
      currencyVariant = _ref.currencyVariant,
      negative = _ref.negative;
  return React__default["default"].createElement(PdfRenderableSplitRow, {
    leftContent: React__default["default"].createElement(Typography, {
      variant: labelVariant
    }, label),
    rightContent: React__default["default"].createElement(Typography, {
      variant: currencyVariant
    }, negative && '-', React__default["default"].createElement(CurrencyDisplay, {
      amountInCents: amount
    }))
  });
};

module.exports = PriceRow;
